import { hooks as head_tag$hooks } from ":src/contexts/head-tag/SHARED/store";
import { hooks as whitelabel$hooks } from ":src/contexts/whitelabel/SHARED/store";

export default {
  head_tag: head_tag$hooks,
  whitelabel: whitelabel$hooks,
};
